"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Terminology;
var _stylesModule = _interopRequireDefault(require("./styles.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function Terminology() {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: _stylesModule.default.howToUseModalContainer,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
      className: _stylesModule.default.howToUseModalTextParagraph,
      children: ["This section briefly details the definitions of the sensors and their properties. For a more detailed description of the sensors, please refer to the ", /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
        href: "https://userguides.robotical.io/martyv2/userguides/sensors-dashboard",
        target: "_blank",
        rel: "noreferrer",
        children: "sensor dashboard user guide"
      }), "."]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: _stylesModule.default.howToUseModalTextTitle,
      children: "Obstacle (IR Foot) Sensor"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
      className: _stylesModule.default.terminologyKey,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
        children: "Obstacle Sensor "
      }), " The intensity of IR light reflected back to the sensor from an obstacle"]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
      className: _stylesModule.default.terminologyKey,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
        children: "Obstacle Detected? "
      }), " The sensor\u2019s best guess as to whether an obstacle is present. 1 = obstacle, 0 = no obstacle"]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
      className: _stylesModule.default.terminologyKey,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
        children: "Ambient IR - Front "
      }), " The intensity of IR light received by the obstacle sensor from elsewhere - this will be higher in sunlight!"]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
      className: _stylesModule.default.terminologyKey,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
        children: "Ground Sensor "
      }), " The intensity of IR light reflected back to the ground sensor from a surface. Will be higher on bright, reflective surfaces"]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
      className: _stylesModule.default.terminologyKey,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
        children: "Foot In Air? "
      }), " The sensor\u2019s best guess as to whether the foot is in the air. 1 = foot in air, 0 = foot on ground"]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
      className: _stylesModule.default.terminologyKey,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
        children: "Ambient IR - Bottom "
      }), " The intensity of IR light received by the ground sensor from elsewhere"]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: _stylesModule.default.howToUseModalTextTitle,
      children: "Color Sensor"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
      className: _stylesModule.default.terminologyKey,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
        children: "Brightness "
      }), " How much light is received by the sensor under the foot"]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
      className: _stylesModule.default.terminologyKey,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
        children: "Red Channel "
      }), " How much red light is received by the sensor under the foot"]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
      className: _stylesModule.default.terminologyKey,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
        children: "Green Channel "
      }), " How much green light is received by the sensor under the foot"]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
      className: _stylesModule.default.terminologyKey,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
        children: "Blue Channel "
      }), " How much blue light is received by the sensor under the foot"]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
      className: _stylesModule.default.terminologyKey,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
        children: "Obstacle Sensor "
      }), " The intensity of IR light reflected back to the sensor from an obstacle"]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
      className: _stylesModule.default.terminologyKey,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
        children: "Obstacle Detected? "
      }), " The sensor\u2019s best guess as to whether an obstacle is present. 1 = obstacle, 0 = no obstacle"]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
      className: _stylesModule.default.terminologyKey,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
        children: "Foot In Air? "
      }), " The sensor\u2019s best guess as to whether the foot is in the air. 1 = foot in air, 0 = foot on ground"]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: _stylesModule.default.howToUseModalTextTitle,
      children: "Noise Sensor"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
      className: _stylesModule.default.terminologyKey,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
        children: "Recent Noise Level "
      }), " The average noise level over the last fraction of a second"]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
      className: _stylesModule.default.terminologyKey,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
        children: "Noise level "
      }), " The average noise level over the last 100ms"]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
      className: _stylesModule.default.terminologyKey,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
        children: "Instant Noise Level "
      }), " The noise level this instant - will give higher values than the other options, but is also likely to miss some noises!"]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: _stylesModule.default.howToUseModalTextTitle,
      children: "Light Sensor"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
      className: _stylesModule.default.terminologyKey,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
        children: "Light Level - Right "
      }), " Intensity of light from sensor 1, to Marty\u2019s right if the light sensor is facing forwards"]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
      className: _stylesModule.default.terminologyKey,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
        children: "Light Level - Center "
      }), " Intensity of light from sensor 2, in front of Marty if the light sensor is facing forwards"]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
      className: _stylesModule.default.terminologyKey,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
        children: "Light Level - Left "
      }), " Intensity of light from sensor 3, to Marty\u2019s left if the light sensor is facing forwards"]
    })]
  });
}